import React, { useState } from 'react';
import axios from 'axios';
import { Button, Group, TextInput, Modal, Text, Center, Title } from '@mantine/core';
import { IconGridDots, IconSearch } from '@tabler/icons-react';
import DataTable from 'react-data-table-component';
import useGetImportUser from './useGetImportUser';
import { useNavigate } from "react-router-dom";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import { importUsers } from '../../../api/agent/user';
import { errorNotification, loadingNotification, successNotification } from '../../../utility/notification';
import { notifications } from '@mantine/notifications';
import { useDisclosure } from '@mantine/hooks';
import ActionCell from './components/ActionCell';

const Remote = () => {
    const navigate = useNavigate();
    const { ImportUserQuery: { data, isPending, isError, isRefetching, refetch },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch,
        queryKey,
    } = useGetImportUser();

    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            uploadFile(selectedFile);
        }
    };

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('csv_file', file);

        try {
            loadingNotification({
                title: "Uploading...",
                message: "File uploading in progress."
            })

            const response = await importUsers(formData);
            await refetch(); // Refresh the list after successful upload

            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top on success

        } catch (error) {
            errorNotification({ message: 'Failed to upload CSV' });

        }
    };

    const TikTokLink = ({ username }) => {
        return (
            <a href={`https://www.tiktok.com/${username}`} target="_blank" rel="noopener noreferrer">
                {username}
            </a>
        );
    };

    const columns = [
        {
            name: 'Creator',
            selector: row => <TikTokLink username={row.tiktok_username} />,
            sortable: true,

        },
        // {
        //     name: 'Agent Name',
        //     selector: row => row.agent_name == "" ? 'N/A' : row.agent_name,
        //     sortable: true,
        // },
        {
            name: 'Downloaded FAME',
            selector: row => row.is_app_downloaded ? 'Yes' : 'No',
            sortable: true,
        }
        , {
            name: 'Action',
            cell: row => <ActionCell row={row} queryKey={queryKey} />,
            // width: "100px",

        }
    ];

    const handleClick = () => {
        document.getElementById('csvInput').click();
    };

    const [opened, { open, close }] = useDisclosure(false);
    return (
        <LoadingErrorContainer
            isError={isError}
            isLoading={isPending}
            isRefetching={isRefetching}
        >
            <Group justify='space-between'>
                <Title order={3}>Users</Title>
                <Group>
                    <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />
                    <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="csvInput"
                        onClick={(event) => {
                            event.target.value = null
                        }}
                    />
                    {/* <Button
                        variant="gradient"
                        gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                        onClick={handleClick}
                        leftSection={<IconGridDots style={{ width: '1rem', height: '1rem', alignSelf: "flex-end" }} />}
                    >Upload CSV to Import Users</Button> */}

                </Group>
            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}
                paginationPerPage={100}
                paginationRowsPerPageOptions={[100, 150, 200, 250, 300]}
            />
        </LoadingErrorContainer>
    );
}

export default Remote;
